import CartCounter from './CartCounter'

export default CartCounter